export default "__VITE_ASSET__CWuQ91K7__"